<template>
    <div class="StoreInfoWeb">
        <el-header class="app-header">
            <el-row type="flex" justify="space-between" class="h-100 items-center">
                <!--todo 手機版，開啟側邊欄用-->
                <el-col :span="7" class="text-left" @click.native="toggle">
                    <el-button type="text" class="hamburger"/>
                </el-col>
                <el-col :span="17" class="text-center d-flex" @click.native="goMember" v-if="isLogin">
                    <div class="avatar" :class="{active : tabNum===4}">
                        <div class="image_empty" v-if="avatar===''"/>
                        <el-image v-else :src="avatar" fit="cover" lazy/>
                    </div>
                    <div class="name">Hi~ {{userData.name}}</div>
                </el-col>
            </el-row>
        </el-header>
        <div class="main">
            <!--返回LINE-->
            <el-button type="text" class="back-line" v-if="isLineBasicId" @click="backLine()">
                <img src="@/assets/images/share-line.svg"/>
            </el-button>

            <banner :list="storeImgAry" :store="Number(1)"/>

            <div class="top-block d-flex">
                <div class="store-name" @click="goStore">
                    <img :src="isNoteIconEmpty(storeInfo.imgUrl) ? storeInfo.imgUrl:''">
                    <h2>{{storeInfo.brandName}} <span class="ml-3">{{storeInfo.name}}</span></h2>
                </div>
                <div class="member-name">
                    <div class="d-flex" @click="goMember" v-if="isLogin">
                        <div class="avatar">
                            <div class="image_empty" v-if="avatar===''"/>
                            <el-image v-else :src="avatar" fit="cover" lazy/>
                        </div>
                        <div class="name">Hi~ {{userData.name}}</div>
                    </div>

                    <div @click.stop="goLogout" v-if="isLogin" class="login">
                        {{ isLineApp ? "解除綁定" : "登出" }}
                    </div>
                    <div @click.stop="goLogin" v-else class="login">
                        <div class="avatar">
                            <div class="image_empty"/>
                        </div>
                        登入
                    </div>
                </div>

                <div class="booking-block">
                    <el-button round type="warning" @click="onClickBooking">訂位</el-button>
                </div>
            </div>

            <div class="scan-btn" @click="goScan" v-if="isLogin">
                <img src="@/assets/images/qrcode2.svg">
                <span>會員條碼</span>
            </div>

            <!--todo 主選單-->
            <div class="mainLeftArea" id="mainLeftArea">
                <ul class="menu-content">
                    <li @click="goStore" :class="{active : tabNum===5}">
                        <span>店家</span>首頁
                    </li>
                    <li @click="goRewardPoint" :class="{active : tabNum===0}" v-show="rewardPointEnable">
                        我的點數
                    </li>
                    <li @click="goCoupon" :class="{active : tabNum===1}" v-show="couponEnable">
                        我的票券
                    </li>
                    <li @click="goLoyaltyCard" :class="{active : tabNum===2}" v-show="loyaltyCardEnable">
                        我的集點卡
                    </li>
                    <li @click="goOinCard" :class="{active : tabNum===3}" v-show="actCardEnable">
                        我的活動卡
                    </li>
                    <li @click="goMember" :class="{active : tabNum===4}">
                        <span>個人中心 / </span>訂位查詢
                    </li>

                    <li @click="goLogout" v-if="isLogin" class="login">
                        {{ isLineApp ? "解除綁定" : "登出" }}
                    </li>
                    <li @click="goLogin" v-else class="login">
                        登入
                    </li>

                </ul>
                <div @click="closeSideBar" class="closed-box"/>
            </div>
            <ul class="menu-coupon" v-if="isLogin">
                <li @click="goRewardPoint" :class="{active : tabNum===0}" v-show="rewardPointEnable" v-if="rewardPointStatusType">
                    <b>{{ displayCount(rewardPoint) }}</b>
                    <span>點數</span>
                </li>
                <li @click="goCoupon" :class="{active : tabNum===1}" v-show="couponEnable" v-if="couponStatusType">
                    <b>{{ displayCount(couponCount) }}</b>
                    <span>票券</span>
                </li>
                <li @click="goLoyaltyCard" :class="{active : tabNum===2}" v-show="loyaltyCardEnable" v-if="loyaltyCardStatusType">
                    <b>{{ displayCount(loyaltyCardCount) }}</b>
                    <span>集點卡</span>
                </li>
                <li @click="goOinCard" :class="{active : tabNum===3}" v-show="actCardEnable" v-if="cardStatusType">
                    <b>{{ displayCount(actCardCount) }}</b>
                    <span>活動卡</span>
                </li>
            </ul>
            <router-view/>
        </div>

        <!--todo 未登入提醒-->
        <comm-dialog :value="isShowLogin"
                     :outerContent="'請先登入'"
                     @result="onShowLoginDialogClose"/>

        <!--todo 登出提醒-->
        <logout :value="logoutDialog" @close="(value) => { onLogout(value); }" />

        <!--todo 掃碼手勢下滑關閉--->
        <PullDownClose v-if="isShowPullDownScan" @close="closePullDownScan">
            <!-- 增加監聽重刷畫面 -->
            <Scan class="content" :openScanType="openScanType.MainStoreWeb" @result="giftReload"/>
        </PullDownClose>

        <!--todo 登入手勢下滑關閉--->
        <PullDownClose v-if="isShowPullDownLogin" @close="closePullDownLogin" class="login-Pull">
            <Login class="content" isWeb @close="closePullDownLogin"/>
        </PullDownClose>

    </div>
</template>

<script>
    import Banner from '@/components/BannerSlider.vue';
    import CommDialog from "@/components/CommDialog";
    import Logout from "@/views/more/components/Logout";
    import PullDownClose from "@/components/PullDownClose";
    import Scan from "@/views/scan/Index";
    import Login from  "@/views/auth/Login"
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    import * as mutationTypes from '@/store/mutationTypes';
    import * as constDefine from '@/store/constDefine';
    import Line from '@/util/line';

    const eventTypeConst = {//-1是不執行任何動作
        openUrlWithCloseBtn: -2,
        addMember: 2,
        qrcodeSendCoupon: 3,
        qrcodeSendLoyaltyCard: 4,
        qrcodeSendRewardPoint: 5,
        qrcodeSendGiftPack: 6,
    };

    export default {
        name: "StoreInfo",
        computed: {
            openScanType() {
                return constDefine.OpenScanType
            }
        },
        components: {
            Banner,
            CommDialog,
            Logout,
            PullDownClose,
            Scan,
            Login,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
                // isLogin: false,
                storeCode: this.$route.params.storeCode, //從router寫入的
                //店家輪播圖
                storeImgAry: [],
                //會員頭像
                avatar: '',
                userData: {
                    name: '',
                },
                storeInfo: {
                    id: 0,

                    address: '',
                    bookingStatus: 0,       // 不明？
                    bookingUrl: '',         // 線上訂位網址
                    brandId: undefined,
                    brandName: '',
                    businessHours: {
                        monday: [],
                        tuesday: [],
                        wednesday: [],
                        thursday: [],
                        friday: [],
                        saturday: [],
                        sunday: [],
                        businessStatusString: '',
                        endBusinessTimePeriodString: '',
                    },
                    city: '',
                    couponInfoAry: [],          //店家優惠券清單
                    ticketInfoAry: [],          //店家搶券清單
                    couponLogoImageList: [],
                    description: '',            //描述
                    descriptionStatus: false,   //是否顯示描述
                    distance: '',               //距離標示文字
                    editBookingUrl: '',         //線上訂位網址
                    facebook: '',
                    googleMapUrl: '',        //google地圖 url
                    imageAry: [],
                    imgUrl: '',             //店家 logo
                    instagram: '',
                    lat: 0,
                    lng: 0,
                    maxPrice: 0,
                    menuImageAry: [],
                    minPrice: 0,
                    name: '',
                    noteAry: [],      //備註
                    noteIcon: '',             //備註的 icon
                    noteStatus: false,        //備註是否顯示
                    officialWebsite: '',
                    officialWebsiteStatus: false,
                    onlineOrderStatus: false,
                    photoStatus: false,
                    priceStatus: false,
                    recommendList: [],          //推薦商品區
                    recommendStatus: false,     //推薦商品開啓狀態
                    tel: '',
                    tel2: '',
                    title: '',              //備註的標題
                    township: '',
                    youtube: '',            //影片網址
                    websites: '',           //社群連結網址
                    websiteStatus: false,   //社群連結開關

                },
                encryptUrlSegment: '',      //訂位網頁參數加密
                rewardPoint: 0,             //紅利點數
                couponCount: 0,             //優惠券
                loyaltyCardCount: 0,        //集點卡
                actCardCount: 0,            //活動卡
                rewardPointEnable: false,   //紅利點數開放
                couponEnable: false,        //優惠券開放
                loyaltyCardEnable: false,   //集點卡開放
                actCardEnable: false,       //活動卡開放
                //請先登入彈框
                isShowLogin: false,
                //登出彈框
                logoutDialog: false,
                //目前路由名稱
                routerName: this.$route.name,
                isShowPullDownScan: false,
                isShowPullDownLogin: false,
                //目前索引值
                tabNum: '',

                scanResult: '',
                paramData: {},
                removeSubscribe: {},

                // 網頁版享樂遊回調位置
                path: '',
                isWeb: false,
                isLine: false,

                lineBasicId: '',
                isLineBasicId:false,

                couponStatusType: false, // 店家票券開關
                loyaltyCardStatusType: false, // 店家集點卡開關
                rewardPointStatusType: false, // 店家紅利點數開關
                cardStatusType: false, // 店家活動卡開關

                isLineApp: Line.isLineApp(), // 判斷當前是否在Line App下開啟為true

            }
        },
        created() {
            // 網頁版用
            // 取得相機內容
            if (window.cordova) {
                // 這是 App (Cordova)
            } else {
                // 網頁版
                this.isWeb = true;
            }
            // 取得網址
            this.pathSplit();
            // 以上

            //開啓eventBus事件接收，從 StoreInfo.vue來的
            // this.$eventBus.$on('store-event', this.storeEventHandleEvent);
            if(this.$auth.isAdminLogin() && !this.$public.isCordova()) {
                if(Number(this.$crypto.decryptText(this.$auth.getAdminToken()).split(";")[0]) < 0) {
                    this.$auth.setAdminToken('');
                    this.isLogin = false
                }
            }

            let isShowPullDownScan = sessionStorage.getItem("isShowPullDownScan");
            let isLine = sessionStorage.getItem("isLine");
            if (isLine && isShowPullDownScan) {
                sessionStorage.removeItem("isLine");
                sessionStorage.removeItem("isShowPullDownScan");
                this.isShowPullDownScan = true;
                this.goScan();
            }
        },
        beforeDestroy() {
            this.removeSubscribe();
            //關閉eventBus事件接收
            // this.$eventBus.$off('store-event', this.storeEventHandleEvent);
            //關閉前將給子元件用的單獨過濾的店家ID清空，line@ web版頁面用
            // this.$store.commit(mutationTypes.updateFilterStoreId, 0);
        },
        mounted() {
            this.removeSubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type === "updateStoreWebAction") {
                    if (mutation.payload.action === "goRewardPoint" && this.rewardPointEnable) {
                        this.goRewardPoint()
                    }
                }
            });

            //頁面重整時，tabNum抓取
            if (this.$route.name==='WebStoreRewardPoint'){

                this.tabNum = 0;
            } else if (this.$route.name==='WebStoreCoupon'){
                this.tabNum = 1;
            } else if (this.$route.name==='WebStoreLoyaltyCard'){
                this.tabNum = 2;
            } else if (this.$route.name==='WebStoreOinCard'){
                this.tabNum = 3;
            } else if (this.$route.name==='WebStoreMember'){
                this.tabNum = 4;
            } else {
                this.tabNum = 5;
            }

            if (this.storeInfo.id === 0) {
                this.setupData();
            }

            if (localStorage.getItem('openScanType') === this.openScanType.MainStoreWeb) {
                this.isShowPullDownScan = true
                localStorage.removeItem('openScanType')
            }

            //讀取相機掃描結果，如果有已存的掃描結果，就開啓優惠掃碼界面
            let scanResult = localStorage.getItem('cameraResult');
            //NOTE 由 ScanIndex 相機回來的一定要isShowPullDownScan = true，讓它跑那邊的程式碼
            //NOTE setTimeout是為了優先跑其他vue的，沒有再跑這裡
            if (scanResult !== null && scanResult !== '') {
                setTimeout(() => {
                    //讀取掃描結果
                    //掃描結果在 sessionStorage.getItem('cameraResult') 與 state.scanResult都有一份
                    let scanResult = localStorage.getItem('cameraResult');
                    if (scanResult !== null && scanResult !== '') {
                        //讀取完要清除，要再取得結果就要重新掃描
                        localStorage.setItem('cameraResult', '');
                        this.onScanResult(scanResult);
                    }
                }, 1000) ;
            }
        },
        methods: {
            //掃碼領取coupon券 畫面刷新
            giftReload(result) {
                if (result === "getCoupon") {
                    window.location.reload();
                }
            },

            // 取得路徑
            pathSplit() {
                let pathArr = this.$route.path.split("/");
                if(pathArr.length === 3 && pathArr[1] === 'web-store-info'){
                    this.path = this.$route.path;
                } else if(pathArr.length === 4 && pathArr[1] === 'web-store-info' && (
                    pathArr[3] === 'member' || pathArr[3] === 'reward-point' ||
                    pathArr[3] === 'coupon' || pathArr[3] === 'loyalty-card' || pathArr[3] === 'oin-card'
                )){
                    this.path = this.$route.path;
                } else {
                    this.path = '';
                }
            },

            /**  */
            setupData: function () {

                let self = this;
                self.callGetStoreInfoByCodeApi(self.storeCode, 0, 0)
                    .then( () => {
                        //像這邊的用法 (外面有函式括號，但裡面沒有用 return)， then就不會等待 isJoinBrandMember回傳結果
                        //then 呼叫了 isJoinBrandMember以後，就直接往下繼續執行了
                        return self.callGetUserTicketsDataApi(self.storeInfo.id);
                    })
                    .then( () => {
                        //像這邊的用法 (外面有函式括號，但裡面沒有用 return)， then就不會等待 isJoinBrandMember回傳結果
                        //then 呼叫了 isJoinBrandMember以後，就直接往下繼續執行了
                        if (self.isLogin) {
                            self.userData = getCryptoUserInfo();
                            self.avatar = self.userData.picture;
                            self.combineBookingParams();
                        }
                    })
                    .catch( (error) => {
                        self.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },

            /** 呼叫 取得 user票券資訊api */
            callGetUserTicketsDataApi (filterStoreId) {
                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {

                    if (self.isLogin) {
                        self.$http.fetchWithAuthEncrypt`GetUserTicketsData${{
                            filterStoreId: filterStoreId,
                        }}${json => {
                            if (self.$public.notNull(json.data)) {
                                self.rewardPoint = json.data.rewardPointCount ;
                                self.couponCount = json.data.couponCount ;
                                self.loyaltyCardCount = json.data.loyaltyCount ;
                                self.actCardCount = json.data.actCardCount ;
                                self.rewardPointEnable = json.data.rewardPointEnable ;   //紅利點數開放
                                self.couponEnable = json.data.couponEnable ;       //優惠券開放
                                self.loyaltyCardEnable = json.data.loyaltyCardEnable ;  //集點卡開放
                                self.actCardEnable = json.data.actCardEnable ;       //活動卡開放
                                self.couponStatusType = json.data.couponStatusType === 1;
                                self.loyaltyCardStatusType = json.data.loyaltyCardStatusType === 1;
                                self.rewardPointStatusType = json.data.rewardPointStatusType === 1;
                                self.cardStatusType = json.data.cardStatusType === 1;

                                resolve();
                            } else {
                                self.$public.showNotify(json.message, false);
                                reject('失敗');
                            }
                            self.isLoading = false;
                        }}`;
                    } else {
                        resolve();
                    }
                });
            },

            /** 呼叫 取得店家資訊api */
            callGetStoreInfoByCodeApi (storeCode, lng, lat) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetStoreInfoByCode${{
                        storeCode: storeCode,
                        lng: lng,
                        lat: lat,
                    }} ${json => {
                        self.isLoading = false;
                        if (json.data.botBasicId !== "" && json.data.botBasicId !== null && json.data.botBasicId !== undefined) {
                            self.lineBasicId = json.data.botBasicId;
                            self.isLineBasicId = true;
                        }

                        if (self.$public.notNull(json.data)) {
                            self.storeInfo = json.data;

                            if (self.$public.notNull(json.data.imageAry) && json.data.imageAry.length > 0) {
                                //轉換成 BannerSlider 可以用的格式
                                self.storeImgAry = json.data.imageAry.map(function (item, index) {
                                    return {
                                        url: '',
                                        imgUrl: item,
                                    }
                                });
                            }

                            //儲存 storeInfo.id
                            self.$store.commit("updateFilterStoreId", self.storeInfo.id);

                            if (!self.isLogin) {
                                //登入畫面要顯示雙 icon，會從 shopAreaInfo 拿到以下資訊，
                                // self.showName = shopAreaInfo.name;
                                // self.path = shopAreaInfo.logoPath;
                                self.$store.commit("updateShopAreaInfo",
                                    {
                                        brandName: self.storeInfo.brandName,
                                        name: self.storeInfo.name,
                                        logoPath: self.storeInfo.imgUrl,
                                    });
                            }

                            resolve();

                        } else {
                            reject(`GetStoreInfoById: 無法取得資料`);
                        }
                    }}`;
                });
            },

            /** 產生訂候位用的參數 */
            combineBookingParams : function() {
                let self = this;
                let usertoken = localStorage.getItem("admin_token");
                let decrypted = self.$crypto.decryptText(usertoken);
                let decrypted_array = decrypted.split(';');

                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                const userData = getCryptoUserInfo();
                let user_name = userData.name;
                let phone = userData.phone;
                let gender = userData.gender;
                let email = userData.email;


                let encryptString = user_name+";"+phone+";"+gender+";"+email+";"+decrypted_array[0]+";"+"isWeb"+";"+encodeURIComponent(window.location.href);
                let encryptedString = self.$crypto.encryptText(encryptString);
                let secondEncrypt = encodeURIComponent(encryptedString);
                self.encryptUrlSegment = secondEncrypt;
                self.userId = decrypted_array[0];
            },

            /** 開啓訂位網頁 */
            loadBooking : function() {
                let self = this;
                let urlSet = this.storeInfo.bookingUrl+"/"+this.encryptUrlSegment;
                // let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                let browser = window;
                //使用 _system的話會呼叫 app外部的 browser來開網頁
                let appInBrowser = browser.open(urlSet, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

            },

            /** eventBus 數據傳遞 */
            storeEventHandleEvent: function (data) {
                if (this.$public.notNull(data)) {
                    //接收店家資料
                    this.storeInfo = data;
                    //儲存
                    if (!this.isLogin) {
                        //登入畫面要顯示雙 icon，會從 shopAreaInfo 拿到以下資訊，
                        // self.showName = shopAreaInfo.name;
                        // self.path = shopAreaInfo.logoPath;
                        this.$store.commit("updateShopAreaInfo",
                                                {
                                                    brandName: data.brandName,
                                                    name: data.name,
                                                    logoPath: data.imgUrl,
                                                });
                    }
                    this.setupData();
                }
            },

            /** icon是否爲空？ */
            isNoteIconEmpty: function(noteIcon) {
                return (this.$public.notNull(noteIcon) && noteIcon !== '');
            },

            toggle(){
                if(document.getElementById("mainLeftArea")){
                    document.getElementById("mainLeftArea").classList.add("openBox");
                }
                document.body.style.overflow="hidden";
            },
            closeSideBar(){
                this.routerName=this.$route.name
                if(document.getElementById("mainLeftArea")){
                    document.getElementById("mainLeftArea").classList.remove("openBox");
                }
                document.body.style.overflow="initial";
            },
            //請先登入彈框關閉事件
            onShowLoginDialogClose(result){
                this.isShowLogin = false;
                if (result) {
                    this.goLogin();
                }
            },
            //前往店家首頁
            goStore() {
                this.closeSideBar();
                this.routerName !== 'WebStoreInfo' && this.$router.replace({ name: 'WebStoreInfo' });
                this.tabNum = 5;
            },
            //登入後-前往會員中心
            goMember() {
                this.closeSideBar();
                if(this.isLogin){
                    this.routerName !== 'WebStoreMember' && this.$router.replace({ name: 'WebStoreMember' });
                    this.tabNum = 4;
                }else {
                    this.isShowLogin = true;
                }
            },
            //登入後-前往紅利點數
            goRewardPoint() {
                this.closeSideBar();
                this.tabNum = 0;
                if (this.isLogin) {
                    this.routerName !== 'WebStoreRewardPoint' && this.$router.replace({name: 'WebStoreRewardPoint'});
                } else {
                    this.isShowLogin = true;
                }
            },

            /** 當 點擊訂位 時 */
            onClickBooking: function() {
                if (this.isLogin) {
                    this.loadBooking();
                } else {
                    this.isShowLogin = true;
                }
            },

            /** 當 登出 時 */
            onLogout: function(value) {
                this.logoutDialog = value;
                if (!this.$auth.isAdminLogin()) {
                    this.userData = {
                        name: '',
                    };
                    this.avatar = '';
                    this.$router.replace('/web-store-info/'+this.$route.params.storeCode);
                    window.location.reload();
                }
            },

            //登入後-前往票券
            goCoupon() {
                this.closeSideBar()
                this.tabNum = 1;
                if (this.isLogin) {
                    this.routerName !== 'WebStoreCoupon' && this.$router.replace({name: 'WebStoreCoupon'});
                } else {
                    this.isShowLogin = true;
                }
            },
            //登入後-前往集點卡
            goLoyaltyCard() {
                this.closeSideBar();
                this.tabNum = 2;
                if (this.isLogin) {
                    this.routerName !== 'WebStoreLoyaltyCard' && this.$router.replace({name: 'WebStoreLoyaltyCard'});
                } else {
                    this.isShowLogin = true;
                }
            },
            //登入後-前往活動卡
            goOinCard() {
                this.closeSideBar()
                this.tabNum = 3;
                if (this.isLogin) {
                    this.routerName !== 'WebStoreOinCard' && this.$router.replace({name: 'WebStoreOinCard'});
                } else {
                    this.isShowLogin = true;
                }
            },
            //登入後-前往優惠掃碼
            goScan() {
                if (this.isLogin) {
                    this.isShowPullDownScan = true
                } else {
                    this.isShowLogin = true;
                }
            },
            //登出
            goLogout(){
                this.closeSideBar();
                this.logoutDialog = true;
            },
            //登入
            goLogin(){
                this.closeSideBar();
                this.isShowPullDownLogin = true;
            },

            //關閉下滑彈窗
            closePullDownScan(){
                this.isShowPullDownScan = false;
            },

            //關閉下滑彈窗
            closePullDownLogin(){
                this.isShowPullDownLogin = false;
                this.setupData();
            },

            /** 接收掃描結果 */
            onScanResult: async function(value) {
                this.scanResult = value;

                if (value.toLowerCase().startsWith('begin:vcard', 0)) {
                    //如果是名片
                    await this.handleVCard(value);

                } else if (value.startsWith('http://', 0) || value.startsWith('https://', 0)) {
                    //如果是網頁
                    await this.handleWebUrl(value);

                } else {
                    //其他處理
                    await this.handleOtherScanResults(value);
                }
            },

            /** 處理名片vCard */
            handleVCard: async function(scanResult) {
                let os = this.$http.getOS();
                if (os === 'Android' || os === 'iOS') {
                    let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                    customPlugin.insertContacts(scanResult);
                }
            },

            /** Web URL 邏輯 */
            handleWebUrl: async function(scanResult) {
                let url = scanResult;

                if (url.startsWith('https://waiting.', 0) || url.startsWith('https://waiting-test.', 0)) {
                    //如果是候位網址
                    await this.handleWebUrl_Waiting(url);

                } else if (url.startsWith('https://o-test.oinapp.com/') || url.startsWith('https://o.oinapp.com/')) {
                    //短網址轉換還原
                    let data = await this.getOriginalURL(url);
                    let extUrl = data.url;

                    //判斷短網址
                    if (extUrl.startsWith('https://survey.oinapp', 0) || extUrl.startsWith('https://survey-test.oinapp', 0)) {
                        //是問卷就處理問卷
                        let isOpened = await this.handleWebUrl_Survey(extUrl);
                        if (!isOpened) {
                            //桌邊服務判斷與處理
                            isOpened = await this.handleWebUrl_TableSideService(new URL(scanResult));
                        }

                        if (!isOpened) {
                            //非系統問卷也不是桌邊服務
                            //開啓網頁, type = 1
                            this.openUrl = extUrl;
                            this.showDialog('是否前往外部網頁？', '', true, 1);
                            return false;
                        }
                    }
                } else {
                    this.handleWebUrl_TableSideService(new URL(scanResult))
                }
            },

            /** 處理 候位URL */
            handleWebUrl_Waiting: async function(scanResult) {
                // 處理候位URL
                let url = scanResult + '/' + this.$crypto.decryptText(window.localStorage.getItem('token')).split(';')[0] + '?t=app';

                let self = this;
                let loop = null;
                // let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                let appInBrowser = window.cordova.InAppBrowser.open(url, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                if (this.$public.isCordova()) {
                    appInBrowser.addEventListener('message', function(...args) {
                        if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                            let msgObj = args[0];
                            if (msgObj.type === 'message') {
                                if (self.$public.notNull(msgObj.data) &&
                                    self.$public.notNull(msgObj.data.message)){
                                    if (msgObj.data.message === 'close') {
                                        appInBrowser.close();
                                    }
                                }
                            }
                        }
                    }, false);

                    //監聽 '載入完成' 事件
                    appInBrowser.addEventListener('loadstop', function(event) {
                        loop = setInterval(function() {

                            appInBrowser.executeScript(
                                {
                                    //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                    code: "location.href;"
                                },
                                function( values ) {
                                    //植入另一段 javascript
                                    if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                        values[0].indexOf('waiting/app/home') >= 0) {

                                        clearInterval( loop );
                                        appInBrowser.executeScript({
                                            code: "const messageObj = { message: 'close'};" +
                                                "document.getElementById('closeBtn').addEventListener('click',function(e){" +
                                                "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                "}, false);"
                                        });
                                    }
                                }
                            );
                        }, 1000);
                    }, true);
                }
            },

            /** 處理 問卷或表單URL */
            handleWebUrl_Survey: async function(url) {
                let isOpened = false;
                // 處理問卷 URL 的邏輯
                const getUrlParam = urlDivideAry => {
                    let urlParam = urlDivideAry[1];
                    let paramDecode = decodeURIComponent(urlParam);
                    let paramDecrypto = this.$crypto.decryptText(paramDecode);
                    return JSON.parse(paramDecrypto);
                }

                if (url.includes('questionnaire/')) {
                    let urlDivideAry = url.split('questionnaire/');
                    if (urlDivideAry.length === 2) {
                        let paramData = getUrlParam(urlDivideAry);

                        //需不需要登入？
                        if (paramData.isLogin) {
                            let isLogin = this.$auth.isAdminLogin();
                            if (isLogin) {
                                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                const userData = getCryptoUserInfo();
                                let name = userData.name;
                                let tel = userData.phone;
                                let combo = name + ';' + tel + ';APP';
                                let crypto_ = this.$crypto.encryptText(combo);
                                let param = encodeURIComponent(crypto_);

                                this.$set(paramData, 'isCordova', this.$public.isCordova());
                                url = `${urlDivideAry[0]}questionnaire/${encodeURIComponent(this.$crypto.encryptText(JSON.stringify(paramData)))}`;

                                //開啓網頁, type = 1
                                this.openUrl = url + '/' + param;
                                this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);

                            } else {
                                //沒登入的話就導到登入
                                await this.$router.push({name: 'Login'});
                            }

                            isOpened = true ;
                        }
                    }
                } else if (url.includes('form/')) {
                    let urlDivideAry = url.split('form/');
                    if (urlDivideAry.length === 2) {
                        let paramData = getUrlParam(urlDivideAry);
                        paramData.params.isCordova = this.$public.isCordova();
                        let param = encodeURIComponent(this.$crypto.encryptText(JSON.stringify(paramData)));
                        url = urlDivideAry[0] + 'form/' + param;
                        let isLogin = this.$auth.isAdminLogin();
                        if (isLogin) {
                            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                            const userData = getCryptoUserInfo();
                            let name = userData.name;
                            let tel = userData.phone;
                            let combo = name + ';' + tel + ';';
                            combo += this.$public.isCordova() ? 'app' : 'web';
                            let crypto_ = this.$crypto.encryptText(combo);
                            let param = encodeURIComponent(crypto_);

                            //開啓網頁, type = 1
                            this.openUrl = url + '/' + param;
                            this.showDialog('是否打開台灣享樂遊表單？', '', true, 1);
                        } else {
                            //沒登入的話就導到登入
                            await this.$router.push({name: 'Login'});
                        }
                        isOpened = true;
                    }
                }

                //可能是其他問卷
                if (!isOpened) {
                    //開啓網頁, type = 1
                    this.openUrl = url;
                    isOpened = true ;

                    this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);
                }

                return isOpened;
            },

            /** 處理桌邊服務 URL */
            handleWebUrl_TableSideService: async function(scanURL) {
                let isOpened = false;
                // 處理外部 URL 的邏輯
                try {
                    if(scanURL.search !== "") {
                        let params = scanURL.searchParams;
                        let newParams = {};
                        let openContent = ""

                        for (let pair of params.entries()) {
                            if(pair[0] === "dataToken") {
                                let dataObject = this.$crypto.uriComponentToObject(pair[1])
                                if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrder) {
                                    openContent = "是否打開桌邊服務？"

                                    dataObject.userData = this.$public.getUserData()

                                    newParams[pair[0]] = this.$crypto.objectToURIComponent(dataObject)
                                }
                            }
                        }

                        if(openContent !== "") {
                            scanURL.search = new URLSearchParams(newParams).toString();
                            this.openUrl = scanURL.href;
                            this.showDialog(openContent, '', true, eventTypeConst.openUrlWithCloseBtn);
                            isOpened = true;
                        }
                    }
                } catch (e) {
                    //
                }

                return isOpened;
            },

            /** 處理其他掃描結果 */
            handleOtherScanResults: async function(scanResult) {
                if (scanResult !== "") {
                    this.paramData = JSON.parse(scanResult);
                    if (typeof this.paramData.dataToken !== "undefined") {
                        let dataJson = this.$crypto.decryptText(this.paramData.dataToken);
                        let data = JSON.parse(dataJson);
                        this.paramData = {...this.paramData, ...data};
                    }

                    switch (this.paramData.usedType) {
                        case constDefine.QRCodeUsedType.SendCoupon:
                            if(this.paramData.couponListId > 0) {
                                this.checkIsAddStore();
                            } else {
                                this.showDialog("優惠券資料異常", '', false, -1);
                            }
                            break;
                        case constDefine.QRCodeUsedType.SendLoyaltyCard:
                            if(this.paramData.loyaltyCardListId > 0) {
                                this.checkIsAddStore();
                            } else {
                                this.showDialog("集點卡資料異常", '', false, -1);
                            }
                            break;
                        case constDefine.QRCodeUsedType.SendGiftPack:
                            if(this.paramData.giftPackListId > 0) {
                                this.checkIsAddStore();
                            } else {
                                this.showDialog("禮包資料異常", '', false, -1);
                            }
                            break;
                        case constDefine.QRCodeUsedType.QRCodePay:
                            // 掃描結帳功能
                            this.$router.push({name: `QRcodePay`,
                                query:{
                                    'totalPrice':this.paramData.totalPrice,
                                    'storeId': this.paramData.storeId,
                                    'orderId': this.paramData.orderId
                                }
                            });

                            break;
                        case constDefine.QRCodeUsedType.SendRewardPoint:
                            if(this.paramData.rewardPointListId > 0) {
                                this.checkIsAddStore();
                            } else {
                                this.showDialog("紅利點數資料異常", '', false, -1);
                            }
                            break
                        default:
                            break;
                    }
                }
            },
            displayCount(value) {
                //優惠超過999時只顯示999+
                return value <= 999 ? value : '999+'
            },
            backLine() { //返回LineBot
                //回到LineBot自動開啟底部圖文選單  Android: 會, IOS: 不會
                //以下兩種 在蘋果裝置回到LineBot不會開啟小鍵盤
                window.location.href = 'https://line.me/R/ti/p/' + this.lineBasicId;
                // window.location.href = 'line://ti/p/' + this.lineBasicId;
                //以下兩種 在蘋果裝置回到LineBot會開啟小鍵盤
                // window.location.href = 'line://oaMessage/' + this.lineBasicId;
                // window.location.href = 'https://line.me/R/oaMessage/' + this.lineBasicId;
            }
        },
    }
</script>

<style lang="less" scoped src="@/less/storeWeb.less"/>
